import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatRadioModule } from '@angular/material/radio'
import { MatSidenavModule } from '@angular/material/sidenav'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { MatTabsModule } from '@angular/material/tabs'
import { RouterModule } from '@angular/router'
import { IonicModule } from '@ionic/angular'
import { TranslateModule } from '@ngx-translate/core'
import { AppLinkDirective } from '../directives/app-link.directive'
import { AppOnlyContentDirective } from '../directives/app-only-content.directive'
import { ButtonToggleOnScrollDirective } from '../directives/button-toggle-on-scroll.directive'
import { ClickDirective } from '../directives/click.directive'
import { HideHeaderDirective } from '../directives/hide-header.directive'
import { LongPressDirective } from '../directives/long-press.directive'
import { MixedTranslationDirective } from '../directives/mixed-translation.directive'
import { ScrollbarThemeDirective } from '../directives/scrollbar-theme.directive'
import { PipesModule } from '../pipes/pipes.module'
import { RequireLoginDirective } from '../directives/require-login.directive'

@NgModule({
  declarations: [
    ScrollbarThemeDirective,
    ClickDirective,
    HideHeaderDirective,
    AppLinkDirective,
    ButtonToggleOnScrollDirective,
    LongPressDirective,
    MixedTranslationDirective,
    AppOnlyContentDirective,
    RequireLoginDirective,
  ],
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatSnackBarModule,
    MatSidenavModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    PipesModule,
  ],
  exports: [
    IonicModule,
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatSnackBarModule,
    MatSidenavModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    PipesModule,
    ScrollbarThemeDirective,
    ClickDirective,
    HideHeaderDirective,
    AppLinkDirective,
    ButtonToggleOnScrollDirective,
    LongPressDirective,
    TranslateModule,
    MixedTranslationDirective,
    AppOnlyContentDirective,
    RequireLoginDirective,
  ],
})
export class SharedModule {}
